import { render, staticRenderFns } from "./RedeCredenciadaListagem.vue?vue&type=template&id=58675919"
import script from "./RedeCredenciadaListagem.vue?vue&type=script&lang=js"
export * from "./RedeCredenciadaListagem.vue?vue&type=script&lang=js"
import style0 from "./RedeCredenciadaListagem.vue?vue&type=style&index=0&id=58675919&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports